import { createFeatureList } from '../list'

export const systemList = {
  ...createFeatureList({
    type: 'SYSTEM',
    icon: 'IconShare',
    title: {
      en: 'Systems',
      sv: 'System'
    },
    mainPathFilter: true
  }),
  component: 'SystemDashboard'
}
